'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BrandBar = require('./BrandBar');

var _BrandBar2 = _interopRequireDefault(_BrandBar);

var _NavBar = require('./NavBar');

var _NavBar2 = _interopRequireDefault(_NavBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// header

var Layout = function Layout(props) {
    var layoutClass = props.hideHeader ? 'no-header' : null;
    var header = props.hideHeader ? null : _react2.default.createElement(
        'nav',
        { className: 'navbar navbar-default navbar-fixed-top', style: { zIndex: 1000003 } },
        _react2.default.createElement(
            'div',
            { className: 'nav-container' },
            _react2.default.createElement(_BrandBar2.default, null),
            _react2.default.createElement(_NavBar2.default, {
                loginCookie: props.loginCookie,
                baseUrl: props.baseUrl,
                sports: props.sports,
                handleLogout: props.handleLogout
            })
        )
    );

    return _react2.default.createElement(
        'div',
        { className: layoutClass },
        header,
        props.children
    );
};

exports.default = Layout;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/navigation/Layout.js
// module id = 792
// module chunks = 0